import { ButtonGroup } from '@mui/material';
import { IsTenantAdministrator } from 'shared/permissions/IsTenantAdministrator';
import ConfirmationButtonDialog from 'components/ui/feedback/ConfirmationButtonDelete';
import { TenantPage } from 'layouts';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { costElementService } from 'shared/services';
import { periodicCostElementService } from 'features/cost-analysis/costs/api/periodic-cost-element.service';
import { loadingActions } from 'store';
import { useAppDispatch } from 'store/store';
import toast from 'shared/utils/toast';
import CostElementForm from '../components/CostElementForm';
import { ICostElement, IPeriodicCostElemet } from '../types';

export function EditCostElement() {
  const { t } = useTranslation();
  const translationPrefix = 'pages.cost.edit';
  const navigate = useNavigate();

  const { costElementId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  let isPeriodical = false;
  isPeriodical = searchParams.get('isPeriodical') === 'true';

  const [costElement, setCostElement] = useState<ICostElement | IPeriodicCostElemet>();

  const dispatch = useAppDispatch();

  useEffect(() => {
    (isPeriodical ? periodicCostElementService : costElementService)
      .get(+costElementId)
      .then(setCostElement);
  }, []);

  const updateCostElement = async (values) => {
    dispatch(loadingActions.startLoading());

    (isPeriodical ? periodicCostElementService : costElementService)
      .update(costElement.id, values)
      .then(() => {
        toast.crud.successUpdate('Elemento di costo');
      });
    dispatch(loadingActions.stopLoading());
  };

  const deleteCost = async () => {
    (isPeriodical ? periodicCostElementService : costElementService)
      .delete(costElement.id)
      .then(() => {
        toast.success(t('actions.successfully.deleted'));
        navigate('..');
      });
    dispatch(loadingActions.stopLoading());
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      entityCode={costElement?.code}
      menuRight={
        <IsTenantAdministrator>
          <ButtonGroup size="small">
            <ConfirmationButtonDialog handleDelete={deleteCost} />
          </ButtonGroup>
        </IsTenantAdministrator>
      }>
      <CostElementForm
        onSubmit={updateCostElement}
        costElement={costElement}
        periodical={isPeriodical}
      />
    </TenantPage>
  );
}

export default EditCostElement;
